import commonResources from "@/common/resources/common";
import { FormattedMessage } from "react-intl";
import { MenuItemDto } from "@emutabakat-types/app";
import React from "react";

const menuItems: MenuItemDto[] = [
  {
    key: "0",
    icon: "play-circle",
    title: <FormattedMessage id={commonResources.mutabakatBaslatma.id} />,
    items: [
      {
        key: "0-0",
        url: "/mutabakat/baslat/musteri",
        title: <FormattedMessage id={commonResources.musteri.id} />,
      },
      {
        key: "0-1",
        url: "/mutabakat/baslat/satici",
        title: <FormattedMessage id={commonResources.satici.id} />,
      },
      {
        key: "0-2",
        url: "/mutabakat/baslat/ba",
        title: <FormattedMessage id={commonResources.bildirimAlis.id} />,
      },
      {
        key: "0-3",
        url: "/mutabakat/baslat/bs",
        title: <FormattedMessage id={commonResources.bildirimSatis.id} />,
      },
      {
        key: "0-3",
        url: "/mutabakat/excelyukle",
        title: <FormattedMessage id={commonResources.karsiMutabakat.id} />,
      },
    ],
  },
  {
    key: "1",
    icon: "solution",
    title: <FormattedMessage id={commonResources.mutabakatTakip.id} />,
    items: [
      {
        key: "1-0",
        url: "/mutabakat/musterisatici",
        title: <FormattedMessage id={commonResources.musteriSatici.id} />,
      },
      {
        key: "1-1",
        url: "/mutabakat/babs",
        title: "BA/BS",
      },
      {
        key: "1-2",
        url: "/mutabakat/musterisatici/view/0",
        title: "M/S Detay Arama",
      },
      {
        key: "1-3",
        url: "/mutabakat/babs/view/0",
        title: "BA/BS Detay Arama",
      },
    ],
  },
  {
    key: "2",
    icon: "global",
    title: <FormattedMessage id={commonResources.anaVeri.id} />,
    items: [
      {
        key: "2-0",
        url: "/anaveri/kullanici",
        icon: "user",
        title: <FormattedMessage id={commonResources.kullanici.id} />,
      },
      {
        key: "2-1",
        url: "/anaveri/musteri",
        icon: "solution",
        title: <FormattedMessage id={commonResources.musteri.id} />,
      },
    ],
  },
];

export default menuItems;
